import {navItems} from '../UI/navigation/types.js'
import type {AppNavigation} from './types.js'

interface AdminNavigationOptions {
    user: {name?: string}
    accounts: unknown[]
    pathname: string
    onClickSwitchAccount: () => void
    onClickLogout: () => void
}

const pages = [
    {key: 'resellers', icon: 'mdi mdi-store', title: 'Resellers', target: '/admin/resellers'},
    {key: 'klanten', icon: 'mdi mdi-account', title: 'Klanten', target: '/admin/klanten'},
    {key: 'zoeken', icon: 'mdi mdi-package-variant-closed', title: 'Zoeken', target: '/admin/zoeken'},
    {key: 'notificaties', icon: 'mdi mdi-text-account', title: 'Notificaties', target: '/admin/notificaties'},
    {key: 'facturen', icon: 'mdi mdi-finance', title: 'Facturen', target: '/admin/facturen'},
    {key: 'logs', icon: 'mdi mdi-finance', title: 'Logs', target: '/admin/logs'}
]

/** The navigation of the admin pages (src/views/admin/Layout.js) */
export function adminNavigation(options: AdminNavigationOptions): AppNavigation {
    const {user, accounts, pathname} = options

    return {
        items: pages.map((page) => ({...page, active: pathname === page.target})),
        endItems: [],
        account: {
            title: user.name,
            subTitle: 'Admin',
            links: navItems([
                accounts.length > 1 && {key: 'wissel', title: 'Wissel account', icon: 'mdi mdi-account-multiple', onClick: options.onClickSwitchAccount},
                {key: 'uitloggen', title: 'Uitloggen', icon: 'mdi mdi-logout', onClick: options.onClickLogout}
            ])
        }
    }
}
